module.exports = __webpack_public_path__ + "img/ad_main3.00b89415.png";